import { render, staticRenderFns } from "./HrSalaryBonusActualDetail.vue?vue&type=template&id=875718a2&scoped=true&"
import script from "./HrSalaryBonusActualDetail.vue?vue&type=script&lang=js&"
export * from "./HrSalaryBonusActualDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryBonusActualDetail.vue?vue&type=style&index=0&id=875718a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875718a2",
  null
  
)

export default component.exports